(() => {
  const SECTION_SELECTOR = '[data-section-type="w-list-collections"]';
  const DESKTOP_BREAKPOINT = 990;

  class WListCollectionsSection {
    constructor(section) {
      this.section = section;
      this.swiperElement = section.querySelector('[data-w-list-swiper]');
      this.paginationElement = section.querySelector('[data-w-list-pagination]');
      this.nextElement = section.querySelector('[data-w-list-next]');
      this.prevElement = section.querySelector('[data-w-list-prev]');
      this.controlsElement = section.querySelector('[data-w-list-controls]');
      this.swiper = null;

      this.boundHandleViewportChange = this.handleViewportChange.bind(this);
      this.mediaQuery = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`);

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.boundHandleViewportChange);
      } else {
        this.mediaQuery.addListener(this.boundHandleViewportChange);
      }

      this.handleViewportChange();
    }

    isDesktop() {
      return this.mediaQuery.matches;
    }

    handleViewportChange() {
      if (this.isDesktop()) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (!this.swiperElement || !window.Swiper || this.swiper) {
        return;
      }

      this.swiper = new Swiper(this.swiperElement, {
        slidesPerView: 4,
        spaceBetween: 16,
        watchOverflow: true,
        pagination: {
          el: this.paginationElement,
          clickable: true,
        },
        navigation: {
          nextEl: this.nextElement,
          prevEl: this.prevElement,
        },
      });

      this.updateControlsVisibility();
      this.swiper.on('lock', () => this.updateControlsVisibility());
      this.swiper.on('unlock', () => this.updateControlsVisibility());
      this.swiper.on('update', () => this.updateControlsVisibility());
      this.swiper.on('resize', () => this.updateControlsVisibility());
    }

    updateControlsVisibility() {
      if (!this.controlsElement || !this.swiper) {
        return;
      }

      this.controlsElement.hidden = this.swiper.isLocked;
    }

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      if (this.controlsElement) {
        this.controlsElement.hidden = false;
      }
    }

    destroy() {
      this.destroySwiper();

      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.boundHandleViewportChange);
      } else {
        this.mediaQuery.removeListener(this.boundHandleViewportChange);
      }
    }
  }

  const sectionInstances = new Map();

  function getSectionKey(section) {
    return section.dataset.sectionId || section.id;
  }

  function initSections(scope = document) {
    const sections = scope.matches && scope.matches(SECTION_SELECTOR)
      ? [scope]
      : scope.querySelectorAll(SECTION_SELECTOR);

    sections.forEach((section) => {
      const key = getSectionKey(section);
      if (sectionInstances.has(key)) {
        return;
      }

      sectionInstances.set(key, new WListCollectionsSection(section));
    });
  }

  function unloadSection(scope = document) {
    const section = scope.matches && scope.matches(SECTION_SELECTOR)
      ? scope
      : scope.querySelector(SECTION_SELECTOR);

    if (!section) {
      return;
    }

    const key = getSectionKey(section);
    const instance = sectionInstances.get(key);

    if (!instance) {
      return;
    }

    instance.destroy();
    sectionInstances.delete(key);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSections());
  } else {
    initSections();
  }

  document.addEventListener('shopify:section:load', (event) => initSections(event.target));
  document.addEventListener('shopify:section:unload', (event) => unloadSection(event.target));
})();
